import React from "react";
import "./Admin.css";
import S3 from "react-aws-s3";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { appCtx } from "../../context";
import { BsCheckLg } from 'react-icons/bs';

function AdminPublishPressClipping() {
  const { isLoggedIn } = useContext(appCtx);
  const navigate = useNavigate();
  const [isSentSuccessfully, setIsSentSuccessfully] = useState(false)
  const [photoToUpload, setPhotoToUpload] = useState(null);
  const [body, setBody] = useState({
    naslov: "",
    slika: "",
    linkURL:""
  });
  const [isValidationFailed, setIsValidationFailed] = useState(false)

  useEffect(() => {
    !isLoggedIn ? navigate("/") : console.log()
  }, [isLoggedIn])

  const uploadImageOnAmazon = () => {
    const config = {
      bucketName: "hocu-da-radim",
      region: "eu-west-1",
      accessKeyId: "AKIAVNPTROJ64MG35EX2",
      secretAccessKey: "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",
    };
    const ReactS3Client = new S3(config);

    ReactS3Client.uploadFile(photoToUpload)
      .then((res) => {
        const lokacija = res.location;
        sendPressClipping(lokacija + "");
      })
      .catch((err) => console.error(err));
  };

  const checkValidation = () => {
    if (body.naslov && body.linkURL) {
      setIsValidationFailed(false)
      uploadImageOnAmazon()
    } else {
      setIsValidationFailed(true)
    }
  }


  const sendPressClipping = (photoURL) => {
    const data = {
      ...body,
      slika: photoURL
    }

    fetch('https://eu-west-1.aws.data.mongodb-api.com/app/website-gyppv/endpoint/publishPressClipping', {
      method: "POST",
      body: JSON.stringify({ data }),
      headers: {
        "Content-Type": "application/json",
      }
    })
      .then((response) => {
        if (response.ok) {
          setIsSentSuccessfully(true)
        } else {
          alert(`Došlo je do greške, pokušaj ponovo`)
        }
      })
  };

  return (
    <div className="admin-container">
      <h1>Objavi Press Clipping</h1>
      <div className="regular-input">
        <input
          type="text"
          name="text"
          id="text"
          placeholder="NASLOV"
          onChange={(event) => {
            setBody({ ...body, naslov: event.target.value });
          }}
        />
        {isValidationFailed && !body.naslov &&
          <p className="validation-msg">Obavezno polje</p>
        }
      </div>
      <div className="regular-input">
        <input
          type="text"
          name="text"
          id="link"
          placeholder="LINK DO STRANICE"
          onChange={(event) => {
            setBody({ ...body, linkURL: event.target.value });
          }}
        />
        {isValidationFailed && !body.linkURL &&
          <p className="validation-msg">Obavezno polje</p>
        }
      </div>

      <label htmlFor="avatar" className="photo-input">
        {!photoToUpload &&
          <span>Postavite fotografiju</span>
        }
        {photoToUpload &&
          <span>Promeni fotografiju</span>
        }
        <input
          type="file"
          id="avatar"
          name="avatar"
          accept="image/png, image/jpg, image/jpeg"
          onChange={(event) => {
            setPhotoToUpload(event.target.files[0]);
          }}
        />
      </label>
      {photoToUpload &&
        <img className="upload-photo-preview" src={URL.createObjectURL(photoToUpload)} alt="fotografija" />
      }

      <button onClick={checkValidation}>OBJAVI</button>
      {isSentSuccessfully &&
        <div className="sent-successufully-modal">
          <h2>Uspešno ste objavili vest</h2>
          <BsCheckLg size={42} color={"#15ff00"} className="checkmark" />
          {setTimeout(function () { window.location.href = "http://omladinskiklaster.rs/" }, 5000)}
        </div>}
    </div>
  );
}

export default AdminPublishPressClipping;
